import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, MotionConfig } from "framer-motion";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import ScrollToTop from "./components/common/ScrollToTop";
import NewsletterPopup from "./components/common/NewsletterPopup";
import NepalReliefPopup from "./components/common/NepalReliefPopup";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Testimonials from "./pages/Testimonials";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import AllEvents from "./pages/AllEvents";
import EventDetail from "./pages/EventDetail";
import EventLanding from "./pages/EventLanding";
import BookATour from "./pages/BookATour";
import TourBooking from "./pages/TourBooking";
import NeeteshTour from "./pages/NeeteshTour";
import Impact from "./pages/Impact";
import Partners from "./pages/Partners";
import AnnualSponsorsPage from "./pages/AnnualSponsors";
import Team from "./pages/Team";
import Media from "./pages/Media";
import Sponsorships from "./pages/Sponsorships";
import "./App.css";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/annual-sponsors" element={<AnnualSponsorsPage />} />
        <Route path="/team" element={<Team />} />
        <Route path="/media" element={<Media />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/all-events" element={<AllEvents />} />
        <Route path="/events/:slug" element={<EventDetail />} />
        <Route path="/services" element={<Services />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/usa-yatra" element={<EventLanding />} />
        <Route path="/book-a-tour" element={<BookATour />} />
        <Route path="/book-a-tour/:tourSlug" element={<TourBooking />} />
        <Route path="/neetesh-tour" element={<NeeteshTour />} />
        <Route path="/sponsorships" element={<Sponsorships />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  // reducedMotion="user" makes every motion component on the site honour the OS
  // setting: transform and layout animations stop, opacity and colour still resolve,
  // so entrances still change state without travelling across the screen.
  return (
    <MotionConfig reducedMotion="user">
      <Router>
        <div className="App">
          <ScrollToTop />
          <a className="skip-link" href="#main-content">Skip to content</a>
          <Header />
          <main id="main-content" tabIndex={-1}>
            <AnimatedRoutes />
          </main>
          <Footer />
          <NepalReliefPopup />
          <NewsletterPopup />
        </div>
      </Router>
    </MotionConfig>
  );
}

export default App;
